module.exports = __webpack_public_path__ + "static/img/157_TO8_1881.0de4cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/157_TO8_1881.jpg
// module id = 990p
// module chunks = 0